import React, { Component } from 'react';
import InfoBox from './InfoBox.js';
import Apartment from '../../../svg/Apartment.js';
import Formsy from 'formsy-react';
import FormsyInputMui from '../../form/FormsyInputMui';
import statesList from '../../../helpers/statesList.js';

class Address extends Component {
  state = {
    serviceAddress: {
      street_address: '',
      street_address_continued: '',
      city: '',
      state: '',
      zip_code: ''
    },
    isCurrentStep: false
  };
  render() {
    const { setStepAsValid, setStepAsInvalid } = this.props;
    const {
      street_address = '',
      street_address_continued = '',
      city = '',
      state = '',
      zip_code = ''
    } = this.state.serviceAddress;
    const { isCurrentStep } = this.state;

    return (
      <React.Fragment>
        <InfoBox
          headline="Where is your kitchen?"
          subline="Please tell us your full service address"
          icon={<Apartment />}
        />

        <Formsy
          onValid={() => setStepAsValid(isCurrentStep)}
          onInvalid={() => setStepAsInvalid(isCurrentStep)}
        >
          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="street_address"
                placeholder="Address 1"
                type="text"
                value={street_address}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="street_address_continued"
                placeholder="Address 2 (optional)"
                type="text"
                value={street_address_continued}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
              />
            </div>
          </div>

          <div className="row">
            <div className="row__item row__item--full">
              <FormsyInputMui
                name="city"
                placeholder="City"
                type="text"
                value={city}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="onboarding-new__small-text-field">
              <FormsyInputMui
                name="state"
                placeholder="State"
                type="text"
                value={state}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                autoComplete="off"
                required
                validations={{
                  validateState: (values, value) => {
                    return this.isStateValid(value);
                  }
                }}
              />
            </div>
            <div className="onboarding-new__small-text-field">
              <FormsyInputMui
                name="zip_code"
                type="text"
                placeholder="Zip"
                value={zip_code}
                onChange={this.handleChange}
                showError={this.state.formIsInvalid}
                required
                validations={{
                  isNumeric: true,
                  isLength: 5
                }}
              />
            </div>
          </div>
        </Formsy>
      </React.Fragment>
    );
  }

  handleChange = e => {
    let { name, value } = e.target;

    if (name === 'zip_code') {
      // no non-digits allowed in zip_code
      if (isNaN(value)) return;
      if (value.length > 5) return;
    }

    if (name === 'state') {
      // limited to 2 letter abbreviations
      if (value.length > 2) return;
      value = value.toUpperCase();
    }

    this.setState({
      serviceAddress: { ...this.state.serviceAddress, [name]: value }
    });
  };

  handleClientUpdate = () => {
    const { serviceAddress } = this.state;

    const updatedClient = {
      service_addresses: [serviceAddress]
    };
    this.props.updateClient(updatedClient);
  };

  isStateValid(str = '') {
    const upperCaseStr = str.toUpperCase();
    return statesList.indexOf(upperCaseStr) >= 0 ? true : false;
  }

  componentDidMount() {
    const { client } = this.props;
    const { service_addresses = [] } = client;

    // Get from props if already set
    if (service_addresses.length > 0) {
      const serviceAddress = service_addresses[0];
      this.setState({ serviceAddress });
    }
  }

  componentDidUpdate(prevProps) {
    const { hasSubmitted, isCurrentStep = false, client } = this.props;

    if (prevProps.client !== client) this.setState({ client });

    if (prevProps.isCurrentStep !== isCurrentStep)
      this.setState({ isCurrentStep });

    if (
      isCurrentStep &&
      hasSubmitted !== prevProps.hasSubmitted &&
      hasSubmitted === true
    ) {
      // Watch for next button click then update client in parent component
      this.handleClientUpdate();
    }
  }
}

export default Address;



// WEBPACK FOOTER //
// ./src/components/new/onboarding/Address.js